import { ReactElement, useMemo } from 'react';
import { Trans } from 'react-i18next';

import { Translate } from '@dreryk/react-common';
import { ModalCancelButton, ModalCloseButton, StrongText } from '@dreryk/react-components';

import { medicalServicesMappingsTranslationKeys } from '../../../translations';

type DocplannerServiceMappingCreateModalExitButtonsProps = {
   readonly onClose: VoidFunction;
   readonly shouldConfirmExit: boolean;
};

const ExitConfirmationSuffix = (): ReactElement => (
   <StrongText testId={'exitConfirm'}>
      <Translate>{medicalServicesMappingsTranslationKeys.unsavedDataWillBeLost}</Translate>
   </StrongText>
);

export const DocplannerServiceMappingCreateModalExitButtons = (
   props: DocplannerServiceMappingCreateModalExitButtonsProps
): ReactElement => {
   const exitButtonConfig = useMemo(
      () => ({
         enabled: props.shouldConfirmExit,
         confirmationButtonLabel: medicalServicesMappingsTranslationKeys.leave,
         content: (
            <Trans
               i18nKey={medicalServicesMappingsTranslationKeys.areYouSureLeavingForm}
               components={{
                  suffix: <ExitConfirmationSuffix />,
               }}
            />
         ),
      }),
      [props.shouldConfirmExit]
   );
   return (
      <>
         <ModalCancelButton onClick={props.onClose} shouldConfirmExit={exitButtonConfig} />
         <ModalCloseButton onClick={props.onClose} shouldConfirmExit={exitButtonConfig} />
      </>
   );
};
